import { render, staticRenderFns } from "./ProductPPL.vue?vue&type=template&id=7a515731&scoped=true&"
import script from "./ProductPPL.vue?vue&type=script&lang=js&"
export * from "./ProductPPL.vue?vue&type=script&lang=js&"
import style0 from "./ProductPPL.vue?vue&type=style&index=0&id=7a515731&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a515731",
  null
  
)

export default component.exports